var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 153 44",
    style: {
      enableBackground: "new 0 0 153 44"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000165948396573426546920000008721895146839562140_);}\r\n\t.st2{fill:url(#SVGID_00000170267904456588402630000004439376606677814178_);}\r\n\t.st3{fill:url(#SVGID_00000069361761219521649420000000946155313530291639_);}\r\n\t.st4{fill:url(#SVGID_00000160192358945832090010000014723650533859450028_);}\r\n\t.st5{fill:url(#SVGID_00000021809143175380870940000001108290302065185164_);}\r\n\t.st6{fill:url(#SVGID_00000179630091312563922430000000796531656526235827_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -0.246,
    y1: 32.0289,
    x2: 151.1716,
    y2: 37.0522
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005586592,
    style: {
      stopColor: "#1EC3AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1EC3F0"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.5,20.8c3.2,0,5.9,1.1,8.2,3.4c2.3,2.2,3.4,5,3.4,8.2v11.3h-2.5V40c0,0,0-0.1-0.1-0.2c-0.1,0-0.2,0-0.2,0.1 C18,42.6,15,44,11.5,44c-3.2,0-5.9-1.1-8.2-3.4c-2.3-2.3-3.4-5-3.4-8.2c0-3.2,1.1-5.9,3.4-8.2C5.6,22,8.4,20.8,11.5,20.8z  M11.5,23.3c-2.5,0-4.7,0.9-6.5,2.7c-1.8,1.8-2.7,3.9-2.7,6.5c0,2.5,0.9,4.6,2.7,6.4c1.8,1.8,3.9,2.7,6.5,2.7 c2.6,0,4.7-0.9,6.4-2.7c1.8-1.8,2.7-3.9,2.7-6.4c0-2.5-0.9-4.7-2.7-6.5C16.2,24.2,14.1,23.3,11.5,23.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179622677816640894590000013590287740908277397_",
    gradientUnits: "userSpaceOnUse",
    x1: -0.2109,
    y1: 30.971,
    x2: 151.2067,
    y2: 35.9943
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005586592,
    style: {
      stopColor: "#1EC3AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1EC3F0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000179622677816640894590000013590287740908277397_)"
    },
    d: "M48.7,20.8c2.1,0,3.9,0.8,5.4,2.3 c1.5,1.5,2.3,3.3,2.3,5.4v15.2H54V28.5c0-1.4-0.5-2.6-1.6-3.7c-1-1-2.2-1.5-3.7-1.5c-1.4,0-2.7,0.5-3.7,1.5c-1,1-1.5,2.2-1.5,3.7 v15.2h-2.4V28.5c0-1.4-0.5-2.6-1.6-3.7c-1-1-2.2-1.5-3.7-1.5c-1.5,0-2.7,0.5-3.7,1.5c-1,1-1.5,2.2-1.5,3.7v15.2h-2.4V28.5 c0-2.1,0.7-3.9,2.2-5.4c1.6-1.5,3.4-2.3,5.4-2.3c2.8,0,4.9,1.2,6.4,3.5C43.9,22,46,20.8,48.7,20.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000144326900429107537610000010787134502321173682_",
    gradientUnits: "userSpaceOnUse",
    x1: -0.1789,
    y1: 30.0067,
    x2: 151.2387,
    y2: 35.03
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005586592,
    style: {
      stopColor: "#1EC3AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1EC3F0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000144326900429107537610000010787134502321173682_)"
    },
    d: "M72.6,20.8c3.2,0,5.9,1.1,8.2,3.4 c2.3,2.2,3.4,5,3.4,8.2v11.3h-2.5V40c0,0,0-0.1-0.1-0.2c-0.1,0-0.2,0-0.2,0.1C79,42.6,76,44,72.6,44c-3.2,0-5.9-1.1-8.2-3.4 c-2.3-2.3-3.4-5-3.4-8.2c0-3.2,1.1-5.9,3.4-8.2C66.7,22,69.4,20.8,72.6,20.8z M72.6,23.3c-2.5,0-4.7,0.9-6.5,2.7 c-1.8,1.8-2.7,3.9-2.7,6.5c0,2.5,0.9,4.6,2.7,6.4c1.8,1.8,3.9,2.7,6.5,2.7c2.6,0,4.7-0.9,6.4-2.7c1.8-1.8,2.7-3.9,2.7-6.4 c0-2.5-0.9-4.7-2.7-6.5C77.2,24.2,75.1,23.3,72.6,23.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031194641210074725650000011966594823776004494_",
    gradientUnits: "userSpaceOnUse",
    x1: -0.0369769,
    y1: 25.7281,
    x2: 151.3807,
    y2: 30.7514
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005586592,
    style: {
      stopColor: "#1EC3AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1EC3F0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031194641210074725650000011966594823776004494_)"
    },
    d: "M91.7,43.7h-2.5V13.8h2.5V43.7z  M102.8,21.3l-7,9.9c-0.2,0.4-0.4,0.8-0.4,1.1c0,0.4,0.1,0.8,0.4,1.2l7.1,10h-3.1L93.8,35c-0.5-0.7-0.8-1.6-0.8-2.6 c0-1,0.3-1.8,0.8-2.6l6-8.5H102.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023963436420215969520000016539688363836060055_",
    gradientUnits: "userSpaceOnUse",
    x1: -0.131,
    y1: 28.5614,
    x2: 151.2867,
    y2: 33.5847
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005586592,
    style: {
      stopColor: "#1EC3AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1EC3F0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023963436420215969520000016539688363836060055_)"
    },
    d: "M116.2,20.8c3.2,0,5.9,1.1,8.2,3.4 c2.3,2.3,3.4,5,3.4,8.2v1.2h-20.1c-0.3,0-0.4,0.1-0.4,0.4c0.4,2.1,1.4,3.9,3.1,5.3c1.7,1.4,3.6,2.1,5.8,2.1c1.8,0,3.5-0.5,5-1.5 c1.5-1,2.6-2.3,3.4-4h2.6c-0.8,2.4-2.2,4.3-4.2,5.8c-2,1.5-4.3,2.2-6.8,2.2c-3.2,0-5.9-1.1-8.2-3.4c-2.3-2.3-3.4-5-3.4-8.2 c0-3.2,1.1-5.9,3.4-8.2C110.3,22,113,20.8,116.2,20.8z M116.2,23.3c-2.1,0-4.1,0.7-5.8,2.1c-1.7,1.4-2.7,3.2-3.1,5.3 c0,0.3,0.1,0.5,0.4,0.5h17.1c0.3,0,0.4-0.2,0.4-0.5c-0.4-2.1-1.4-3.9-3.1-5.3C120.3,24,118.3,23.3,116.2,23.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057857965297846663430000000826604392022608256_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.02042469,
    y1: 27.6963,
    x2: 151.4381,
    y2: 32.7197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005586592,
    style: {
      stopColor: "#1EC3AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1EC3F0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057857965297846663430000000826604392022608256_)"
    },
    d: "M141.8,20.8c2.4,0,4.5,0.9,6.3,2.7 c1.7,1.7,2.6,3.8,2.6,6.3v13.9h-2.4V29.8c0-1.8-0.6-3.3-1.9-4.6c-1.3-1.3-2.8-1.9-4.6-1.9c-1.8,0-3.3,0.6-4.6,1.9 c-1.3,1.2-1.9,2.8-1.9,4.6v13.9h-2.4V29.8c0-2.5,0.9-4.6,2.6-6.3C137.3,21.7,139.4,20.8,141.8,20.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049923527314633358230000016272231395368647087_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.9229,
    y1: 0.4943,
    x2: 152.3405,
    y2: 5.5177
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005586592,
    style: {
      stopColor: "#1EC3AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1EC3F0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049923527314633358230000016272231395368647087_)"
    },
    d: "M153,9.9l-9.9-7c-0.4-0.2-0.8-0.4-1.1-0.4 c-0.4,0-0.8,0.1-1.2,0.4l-10,7.1V6.9l8.6-6.1c0.7-0.5,1.6-0.8,2.6-0.8c1,0,1.8,0.3,2.6,0.8l8.5,6V9.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cb4380350585026b797879cb2d566933.svg";
export { ForwardRef as ReactComponent };